import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Membership from "@/pages/Membership";
import Contact from "@/pages/Contact";
import Events from "@/pages/Events";
import News from "@/pages/News";
import Policies from "@/pages/Policies";
import Privacy from "@/pages/Privacy";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const PublicLayout = () => (
  <SmoothScroll>
    <Navbar />
    <main>
      <Outlet />
    </main>
    <Footer />
  </SmoothScroll>
);

const ProtectedRoute = () => {
  const { user, checking } = useAuth();
  if (checking) return <div className="min-h-screen grid place-items-center bg-navy text-gold font-heading text-xl">Loading…</div>;
  return user ? <Outlet /> : <Navigate to="/login" replace />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ContentProvider>
            <ScrollToTop />
            <Toaster position="top-center" richColors />
            <ErrorBoundary>
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/membership" element={<Membership />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/events" element={<Events />} />
                <Route path="/news" element={<News />} />
                <Route path="/policies" element={<Policies />} />
                <Route path="/privacy" element={<Privacy />} />
              </Route>
              <Route path="/login" element={<Login />} />
              <Route element={<ProtectedRoute />}>
                <Route path="/admin" element={<Admin />} />
              </Route>
            </Routes>
            </ErrorBoundary>
          </ContentProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
